
import ListAltIcon from '@mui/icons-material/ListAlt';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import VaccinesIcon from '@mui/icons-material/Vaccines';
import MapIcon from '@mui/icons-material/Map';
import PeopleIcon from '@mui/icons-material/People';

export const ADMIN_MENU = [
  {
    text: "Inicio",
    route: "/Administrador",
    icon: <DashboardRoundedIcon color='white' />
  },
  {
    text: "Especialidades",
    route: "/Administrador/especialidades",
    icon: <VaccinesIcon color='white' />
  },
  {
    text: "Municipios",
    route: "/Administrador/municipios",
    icon: <MapIcon color='white' />
  },
  {
    text: "Usuarios",
    route: "/Administrador/usuarios",
    icon: <PeopleIcon color='white' />
  },
];

export const USER_MENU = [
  {
    text: "Cita",
    route: "/user/cita",
    icon: <ListAltIcon color='white' />
  },
];

export const OPERADOR_MENU = [
  {
    text: "Agenda",
    route: "/admin/agenda",
    icon: <ListAltIcon color='white' />
  },
];
